import { z } from 'zod';

/**
 * Claude `output_config.effort`: how much the model thinks before answering.
 * Thinking is billed as output tokens, so a lower level is cheaper on tasks
 * that do not need deep reasoning. Omitted means the model's own default,
 * which is high on Opus 4.5 / 4.6 and medium on Opus 5.5.
 */
export const LlmEffortSchema = z.enum(['low', 'medium', 'high', 'xhigh', 'max']);
export type LlmEffort = z.infer<typeof LlmEffortSchema>;

/**
 * Gemini 3.x `thinkingConfig.thinkingLevel`. `minimal` is only offered by the
 * Flash-Lite tier. Gemini bills thinking at the output rate.
 */
export const GeminiThinkingLevelSchema = z.enum(['minimal', 'low', 'medium', 'high']);
export type GeminiThinkingLevel = z.infer<typeof GeminiThinkingLevelSchema>;
